/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, StickyBottomHelper, useFlags } from 'sarsaparilla';
import { RESERVATIONS_ACTION_UPDATE } from '../../constants';

export default function CTABar({
    action,
    onSubmitHandler,
    onShowSummaryModal,
    reservations,
    isSubmitting,
}) {
    const hasReservations = !!reservations.length;
    const { iaPassesGovShutdown } = useFlags();

    if (!hasReservations) {
        return null;
    }

    const ctaCartText =
        action === RESERVATIONS_ACTION_UPDATE ? 'Proceed to Cart' : 'Add to Cart';

    return (
        <div className="ia-cta-bar">
            <StickyBottomHelper scrollingContainerId="page-body">
                <div className="ia-cta-bar-container rec-order-detail-page-actions">
                    <Button
                        className="ia-cta-bar-summary-button"
                        onClick={onShowSummaryModal}
                        appearance="link"
                        isLoading={isSubmitting}
                    >
                        Show Summary
                    </Button>
                    <Button
                        className="ia-cta-bar-cart-button"
                        onClick={onSubmitHandler}
                        isLoading={isSubmitting}
                        isDisabled={iaPassesGovShutdown}
                    >
                        {ctaCartText}
                    </Button>
                </div>
            </StickyBottomHelper>
        </div>
    );
}

CTABar.propTypes = {
    action: PropTypes.string.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    reservations: PropTypes.array.isRequired,
    onShowSummaryModal: PropTypes.any,
    isSubmitting: PropTypes.any,
};
